<!--Qualities Grid-->

<ng-template [ngxPermissionsOnly]="['Quality:View']">
  <div class="company-container">
    <div class="top-part">
      <div class="top-part-wrap">
        <h5 class="table-title">Quality</h5>

        <div
          class="second-section d-flex align-items-center justify-content-end"
        >
          <span matTooltip="Delete Record(s)" matTooltipPosition="above">
            <button
              class="btn filter-btn ms-2"
              data-toggle="modal"
              data-target="#deleteDataModal"
              aria-label="OpenDeleteModal"
              (click)="openConfirmPopup(selectedGradeIDs)"
            >
              <img
                style="width: 22px"
                src="../../../assets/Pricingscreen/delete.svg"
              />
            </button>
          </span>
          <span matTooltip="Export Data" matTooltipPosition="above">
            <button class="btn filter-btn ms-2" (click)="exportToExcel()">
              <img
                style="width: 22px"
                src="../../../assets/Pricingscreen/export.svg"
              />
            </button>
          </span>
          <ng-template [ngxPermissionsOnly]="['Quality:Create']">
            <div
              class="create-btn ms-2 c-pt"
              data-bs-target="#addGradeModal"
              data-bs-toggle="modal"
              (click)="clearForm()"
            >
              <img src="../../../../../assets/icons/whitePlus.svg" />
              Add New
            </div>
          </ng-template>
          <div class="dropdown custom-left ms-2">
            <button
              class="btn dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              id="removeContent"
              matTooltip="More Options"
              matTooltipPosition="above"
              matTooltipClass="raised-tooltip"
            >
              <img src="../../../../assets/Pos-Catalog/importdots.svg" />
            </button>
            <div class="dropdown-menu" id="firstDropdown">
              <div class="first-part">
                <ul class="dropdown-list list-unstyled mb-0">
                  <li>
                    <a class="dropdown-item" (click)="exportQualityTemplate()"
                      ><img
                        class="me-3"
                        src="../../../../assets/Pos-Catalog/arrowDown.svg"
                      />Download Template</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" (click)="importQualityColor()"
                      ><img
                        class="me-3"
                        src="../../../../assets/Pos-Catalog/arrowDown.svg"
                      />Import Quality</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="intro">
      <div class="table-container">
        <table class="table category-table table-condensed" id="mainParent">
          <thead class="main-head sticky-top">
            <tr>
              <th
                scope="col"
                style="align-items: center; width: 20%; text-transform: none"
              >
                <div class="form-check d-flex align-items-center">
                  <input
                    style="height: 20px; width: 20px; margin-right: 10px"
                    class="form-check-input"
                    id="flexCheckDefault1"
                    type="checkbox"
                    [checked]="headerCheckboxSelected"
                    (change)="toggleAllCheckboxes()"
                  />
                  <label for="flexCheckDefault">Quality</label>
                </div>
              </th>
              <th scope="col" style="text-transform: none">Quality Code</th>
              <th scope="col" style="text-transform: none">Quality Color</th>
              <th scope="col" style="text-transform: none">Created On</th>
              <th scope="col" style="text-transform: none">Created By</th>
              <ng-template
                [ngxPermissionsOnly]="['Quality:Update']"
                ||
                [ngxPermissionsOnly]="['Quality:Delete']"
              >
                <th scope="col" style="text-align: center">Actions</th>
              </ng-template>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let grade of gradesarray">
              <td class="d-flex g-2" style="align-items: center">
                <div class="form-check">
                  <input
                    style="height: 20px; width: 20px; margin-right: 10px"
                    class="form-check-input"
                    type="checkbox"
                    [value]="grade.qualityId"
                    id="flexCheckDefault1"
                    [checked]="isSelected(grade)"
                    (change)="handleCheckboxChange($event, grade)"
                  />
                </div>
                <label for="" style="font-size: 14px; font-weight: 700">{{
                  grade.qualityDescr
                }}</label>
              </td>
              <td>{{ grade.qualityCode }}</td>
              <td>
                <span
                  class="bgColor"
                  [style.backgroundColor]="
                    grade.qualityColor ? grade.qualityColor : '#000000'
                  "
                ></span>
              </td>
              <td>{{ grade.createdDt | date : "MM/dd/yyyy" }}</td>
              <td>{{ grade.userName }}</td>
              <ng-template
                [ngxPermissionsOnly]="['Quality:Update']"
                ||[ngxPermissionsOnly]="['Quality:Delete']"
              >
                <td style="text-align: center">
                  <div class="btn-group dropleft" style="gap: 10px">
                    <ng-template [ngxPermissionsOnly]="['Quality:Update']">
                      <span matTooltip="Edit Record" matTooltipPosition="above">
                        <button
                          type="button"
                          class="action-drop"
                          data-bs-target="#addGradeModal"
                          data-bs-toggle="modal"
                          (click)="getGrade(grade)"
                        >
                          <i
                            ><img
                              style="width: 25px"
                              src="../../../assets/Pricingscreen/update.svg"
                          /></i>
                        </button>
                      </span>
                    </ng-template>
                    <ng-template [ngxPermissionsOnly]="['Quality:Delete']">
                      <span
                        matTooltip="Delete Record"
                        matTooltipPosition="above"
                      >
                        <button
                          type="button"
                          class="action-drop ms-2"
                          data-toggle="modal"
                          data-backdrop="static"
                          data-target="#deleteDataModal"
                          aria-expanded="false"
                          (click)="openConfirmPopup(grade)"
                        >
                          <i
                            ><img
                              style="width: 25px"
                              src="../../../assets/Pricingscreen/delete.svg"
                          /></i>
                        </button>
                      </span>
                    </ng-template>
                  </div>
                </td>
              </ng-template>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</ng-template>
<input
  class="d-none"
  #importQuality
  type="file"
  accept=".xlsx, .xls, .csv"
  (change)="onFileChangeImport($event)"
/>
<!-- Button trigger modal -->
<button
  #importModel
  type="button"
  class="btn btn-primary d-none"
  data-bs-toggle="modal"
  data-bs-target="#addbulkuserModal"
></button>
<!-- Modal -->
<div
  class="modal fade"
  id="addbulkuserModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  data-bs-backdrop="static"
>
  <div
    class="modal-dialog modal-dialog-centered modal-dialog-scrollable custom-modal-dialog"
    style="max-width: 50%"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addbulkuserModalLabel">Import Quality</h5>

        <button
          type="button"
          class="btn-close"
          data-bs-toggle="modal"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="closeImportModal()"
        ></button>
      </div>
      <div class="modal-body">
        <div class="tbl-container">
          <table class="table">
            <thead class="sticky-top">
              <tr>
                <th
                  scope="col"
                  style="display: flex; align-items: center; gap: 7px"
                >
                  <input
                    [(ngModel)]="toggleAll"
                    type="checkbox"
                    class="form-check-input formMaster mod m-0"
                    (click)="checkAllImport($event)"
                  />
                  Quality Name
                </th>
                <th scope="col">Quality Color</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let qlty of importQualityList; let i = index">
                <td style="display: flex; align-items: center; gap: 7px">
                  <input
                    [disabled]="qlty.status == 1 || qlty.status == 0"
                    type="checkbox"
                    class="form-check-input formItem mod m-0"
                    [(ngModel)]="qlty.isChecked"
                    (ngModelChange)="isImportEnabled()"
                  />
                  <ng-container *ngIf="qlty.qualityDescr != null">
                    {{ qlty.qualityDescr }}
                  </ng-container>
                </td>
                <td>{{ qlty.qualityColor }}</td>
                <td
                  class="tooltip-container"
                  style="display: flex; align-items: center; gap: 6px"
                  [ngStyle]="{
                    color:
                      qlty.status === null
                        ? '#FFCA28'
                        : qlty.status === true
                        ? '#66BB6A'
                        : '#EF5350'
                  }"
                >
                  <img
                    *ngIf="qlty.status != null"
                    img
                    [src]="
                      qlty.status === false
                        ? '../../../../assets/products-imgs/redError.svg'
                        : qlty.status === true
                        ? '../../../../assets/products-imgs/greenCheck.svg'
                        : ''
                    "
                    alt="Status Image"
                    style="width: 25px; height: 25px; object-fit: contain"
                  />
                  <ng-container class="tooltip-button">
                    <ng-container *ngIf="qlty.status === null">
                      Not added to database
                    </ng-container>
                    <ng-container *ngIf="qlty.status === true">
                      {{
                        qlty.reason == "New Quality created."
                          ? "Added to database"
                          : qlty.reason == "Existing Quality updated"
                          ? "Existing Quality updated"
                          : ""
                      }}
                    </ng-container>
                    <ng-container *ngIf="qlty.status === false">
                      <!-- Show first error -->
                      {{ qlty.reason[0].split("|")[0] }}

                      <!-- Show +count if more errors exist -->
                      <span
                        *ngIf="qlty.reason[0].split('|').length > 1"
                        class="error-count-tooltip"
                        [matTooltip]="getRemainingErrors(qlty.reason[0])"
                        matTooltipClass="error-tooltip"
                      >
                        +{{ qlty.reason[0].split("|").length - 1 }}
                      </span>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button
          [disabled]="isImportDisabled"
          class="btn"
          (click)="addImportedQuality()"
          style="
            background-color: #0070b9;
            color: white;
            display: flex;
            align-items: center;
            gap: 6px;
          "
        >
          <img src="../../../../assets/products-imgs/downloadIcon.svg" /> Import
          selected Quality(s)
        </button>
      </div>
    </div>
  </div>
</div>
<!--Conditions-->
<ng-template [ngxPermissionsOnly]="['Condition:View']">
  <app-conditions></app-conditions>
</ng-template>

<!--Boostrap modal for add new grade-->
<div
  class="modal fade"
  id="addGradeModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <form #form="ngForm">
      <div class="modal-content">
        <div class="custom-modal-header modal-header">
          <h5 class="mb-0">{{ frmQtyText }}</h5>
        </div>
        <div class="custom-modal-body modal-body">
          <div class="modal-body-wraapper">
            <!-- Color Picker -->
            <div class="selector">
              <div class="custom-label">
                <label for="gradeColorInput" class="form-label">Color</label>
                <p>:</p>
              </div>
              <div class="color-picker">
                <p style="padding-left: 12px">Choose Color</p>
                <input
                  class="color1"
                  id="color1"
                  type="color"
                  name="gradeColor"
                  [(ngModel)]="grade.qualityColor"
                />
              </div>
            </div>

            <!-- Title -->
            <div class="selector">
              <div class="custom-label">
                <label for="gradeTitleInput" class="form-label">Title</label>
                <p>:</p>
              </div>
              <input
                type="text"
                class="form-control"
                id="gradeTitleInput"
                name="qualityDescr"
                placeholder="Enter Color Name"
                [(ngModel)]="grade.qualityDescr"
                required
                #title="ngModel"
              />
            </div>

            <!-- Quality Code -->
            <div class="selector">
              <div class="custom-label">
                <label for="gradeCodeInput" class="form-label"
                  >Quality Code</label
                >
                <p>:</p>
              </div>
              <input
                type="text"
                class="form-control"
                id="gradeCodeInput"
                name="qualityCode"
                placeholder="Enter quality code"
                [(ngModel)]="grade.qualityCode"
                required
                #qualityCode="ngModel"
              />
            </div>
          </div>
        </div>

        <!-- Footer Buttons -->
        <div class="custom-modal-footer modal-footer">
          <button
            class="btn modal-btn me-2"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Cancel
          </button>

          <!-- Add Quality -->
          <button
            class="btn modal-btn add-btn"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="creategrade(grade)"
            [disabled]="form.invalid"
            [hidden]="!hideUpdateBtn"
            style="width: auto"
          >
            Add Quality
          </button>

          <!-- Update -->
          <button
            class="btn modal-btn add-btn"
            data-bs-dismiss="modal"
            aria-label="Close"
            (click)="creategrade(grade)"
            [disabled]="form.invalid"
            [hidden]="hideUpdateBtn"
          >
            Update
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!--Boostrap modal for deleting Grade -->
<div
  class="modal fade"
  id="deleteDataModal"
  aria-hidden="true"
  aria-labelledby="exampleModalToggleLabel"
  tabindex="-1"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="deleteButtonClickedWithoutSelection">
        <h5>No Record Selected !</h5>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>
            Are you sure you want to delete the selected Records?<br />
            Or you can make the selected Records inactive.
          </p>
          <p class="fw-bold mt-3">
            Once deleted, all the saved data will get deleted.
          </p>
        </div>
      </div>
      <div class="modal-body" *ngIf="deleteButtonClickedWithoutSelection">
        <div class="modal-body-wraapper">
          <p>Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button
          class="btn modal-btn me-2"
          data-dismiss="modal"
          aria-label="Close"
          #modalConfirmCloseButton
          (click)="highlightedRow(null)"
        >
          Close
        </button>
        <button
          button
          class="btn modal-btn"
          data-dismiss="modal"
          aria-label="Close"
          *ngIf="deleteButtonClickedWithSelection"
          style="background-color: rgb(23, 95, 145); color: white"
          (click)="deleteGrade(deleteParameter)"
        >
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
